<nz-divider></nz-divider>

<h3>Visa Details:</h3>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="durationGroup">
  <div nz-row>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="pr-md">
      <nz-form-label nzRequired>Duration</nz-form-label>
      <nz-form-control [nzErrorTip]="'Duration is Required'">
        <nz-select required id="duration" formControlName="duration">
          <nz-option *ngFor="let d of duration" [nzValue]="d.code" [nzLabel]="d.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="pl-lg">
      <nz-form-label nzRequired>Visa Number</nz-form-label>
      <nz-form-control [nzErrorTip]="'Visa number is Required'">
        <input required id="visaNumber" formControlName="visaNumber" nz-input/>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="pr-md">
      <nz-form-label nzRequired>Start Date</nz-form-label>
      <nz-form-control [nzErrorTip]="'Select Start Date'">
        <nz-date-picker required id="startDate" formControlName="startDate" [nzDisabledDate]="disabledStartDate" nzSize="default" [(ngModel)]="startDate"
          nzPlaceHolder="Start Date" nzFormat="dd-MM-yyyy" (ngModelChange)="onStartChange($event)" (nzOnOpenChange)="handleStartOpenChange($event)">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="pl-lg">
      <nz-form-label nzRequired>End Date</nz-form-label>
      <nz-form-control [nzErrorTip]="'Select End Date'">
        <nz-date-picker required [nzDisabledDate]="disabledEndDate" id="endDate" formControlName="endDate" nzSize="default" [(ngModel)]="endDate" nzPlaceHolder="End Date"
          [nzShowToday]="false" [nzOpen]="endOpen" nzFormat="dd-MM-yyyy" (ngModelChange)="onEndChange($event)" (nzOnOpenChange)="handleEndOpenChange($event)">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="pr-md">
        <nz-form-label nzRequired>Type</nz-form-label>
        <nz-form-control [nzErrorTip]="'Type is Required'">
          <nz-select required id="type" formControlName="type">
            <nz-option *ngFor="let t of type" [nzValue]="t.code" [nzLabel]="t.label"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

  <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="12">
      <nz-form-item class="pr-md" >
        <nz-form-label>Comments</nz-form-label>
        <nz-form-control>
          <textarea rows="2" id="comments" formControlName="comments" nz-input></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="12">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>
  </div>
</form>
